export const subscription = {
  titles: {
    subscription: "Subscription",
    freeTrial: "Free Trial",
    expired: "Expired",
  },

  status: {
    active: "Active",
    canceled: "Canceled",
    trialAccess: "FREE TRIAL",
    expiredAccess: "ACCESS EXPIRED",
  },

  notices: {
    activeDesc: "Manage your subscription details and upgrade options.",
    canceledDesc:
      "Your subscription was canceled. You will keep access until the end date.",
    trialDesc: "You have access to system features until the expiration date.",
    expiredDesc:
      "Your trial period has ended. Subscribe to keep using the service.",
    upgradeHint:
      "Don’t lose access to advanced features, upgrade your subscription now",
    expiredHint:
      "Your access has expired. Subscribe to continue using all features",
    needFullAccess: "Need full access?",
    choosePlan: "Choose a plan that fits you",
  },

  labels: {
    planActive: "Active plan",
    stateNow: "Current status",
    trialPeriod: "Trial period",
    periodExpired: "Expired period",
    summary: "Subscription summary",
    timeLeft: "Time left",
    trialExpiresIn: "Your free trial expires in {days} days",
    expirationDate: "Expiration date",
    nextRenewal: "Next renewal",
    accessUntil: "Access available until",
    perUnit: "/ Per {unit}",
    unitRoom: "Room",
    unitRoomMultiple: "Multiple Rooms",
    unitApartment: "Apartment",
    unitVilla: "Villa",
    unitCamping: "Camping",
    unitLodging: "Lodging",
    annualPlan: "Annual Plan",
    monthlyPlan: "Monthly Plan",
  },

  actions: {
    addUnit: "Add {unitLabel}",
    manageSubAndPayment: "Manage subscription and payment method",
    processing: "Processing...",
    subscribeNow: "Subscribe now",
    chooseAPlan: "Choose a plan",
    goToSubscriptionPage: "Go to plans",
  },

  confirmCancel: {
    title: "Cancel Subscription?",
    text: "If you cancel, you will lose access to your services.",
    confirm: "Yes, cancel",
    cancel: "No",
  },

  formats: {
    priceTotalHTML: "{price}",
    dateDDMMYYYY: "{date}",
  },

  modal: {
    title: 'Subscription Activated!',
    details: "Subscription Details",
    welcomeTitle: "Welcome to WA Checkin {plan}!",
    welcomeBody:
      "You now have full access to our WhatsApp check-in tools, OTA sync, AI chatbot, automations and much more.",
    feature1: {
      title: "Manage rates and availability",
      desc: "Easily edit your prices and control occupancy in real time, all from a single place.",
    },
    feature2: {
      title: "Get direct bookings",
      desc: "From your own website, guests can book directly without going through OTAs.",
    },
    schedule: {
      help: "Schedule a free video call and we’ll help you configure everything.",
      cta: "Schedule video call",
    },
  },

  sectionPlans: {
    title: "Plans list",
    confirm: {
      header: "Confirm plan upgrade",
      loadingMsg: "Updating your plan, please wait.",
      body: "You are about to change your account plan to {plan}.",
    },
    actions: {
      cancel: "Cancel",
      confirmUpgrade: "Confirm upgrade",
      goToBilling: "Go to billing methods",
      accept: "OK",
      updateSubscription: "Update Subscription", // NEW
    },
    success: {
      title: "Success",
      body: "Your subscription has been updated.",
    },
    errors: {
      processTitle: "Error processing request",
      unknownUpdate: "Unknown error while updating the subscription.",
      genericTitle: "Error",
      genericBody: "The subscription could not be updated.",
    },
  },

  plans: {
    features: {
      installation: "Personalized onboarding with an expert",
      fastSupport: "Fast support via email, chat and phone",
      whatsappCheckin: "Check-in via WhatsApp",
      linkEmailCheckin: "Check-in via link / email",
      welcomeMessage: "Welcome message via WhatsApp and email",
      digitalSignature: "Digital signature of policies",
      idScanner: "ID/Passport scanner",
      sesHospedajesSend: "Automatic police reports submission",
      reviewLink: "Send Google review link after check-out",
      smartLocks: "Connect with your smart locks",
      channelManager1: "Channel Manager (Connection with 1 OTA)",

      includesLite: "Everything in Lite",
      selfieVerification: "Guest verification at check-in with selfie",
      unifiedInbox: "Unified inbox",
      upsellServices: "Offer services and experiences via WhatsApp",
      paymentLinks: "Guest charges (card payment link)",
      websiteBookings: "Booking website with synced calendar",
      channelManagerUnified: "Channel Manager (Unified calendars, 100+ OTAs)",
      channelManagerCentralPrices:
        "Channel Manager (Centralized price management)",
      guestSupportOption: "Option to hire Guest Support",

      includesStandard: "Everything in Standard",
      centralizedPriceManager: "Centralized price manager",
      aiChatbot: "WhatsApp AI Chatbot (FAQ & automation)",
      googleVacationRentals: "Google Vacation Rentals integration",
      whatsappReminders: "WhatsApp reminders for guests",
      eInvoicingSoon: "E-invoicing (Coming soon)",
      prioritySupport: "Priority support",
    },
  },

  planCard: {
    perSlash: "/per", // separator "/per {unit}"
    infoTitle: "Plan details",
    update: "Update",
    subscribe: "Subscribe",
    currentPlan: "Current plan",
    byApartment: "per apartment",
    byVilla: "per villa",
    byCamping: "per campsite",
    byRoom: "per room",
    byUnit: "per unit",
  },

  services: {
    title: "Additional services",
    ctaComingSoon: "Coming soon",
    guestSupport: {
      title: "Guest Support Service",
      subtitle: "We handle WhatsApp and phone calls from your guests for you.",
      desc: "We assist them with check-in, answer their questions, and also handle direct booking calls. You relax while they get a 10/10 experience from the first contact.",
    },
    chatbot: {
      title: "AI ChatBot",
      activeService: "Active Service",
      desc: "Add the AI chatbot service and automate your guests' inquiries quickly and efficiently.",
      activateCta: "Activate service",
      confirm: {
        header: "Confirm Activation",
        loadingMsg: "Activating ChatBot service, please wait.",
        body: "You are about to activate the AI ChatBot service for your {units} properties.",
      },
      discount: {
        applied: "Discount applied:",
        couponFallback: "Coupon",
      },
      pricing: {
        unitPrice: "Unit price:",
        quantity: "Quantity:",
        totalToPay: "Total to pay:",
      },
    },
  },

  invoices: {
    title: "Invoices & Receipts",
    created: "Created",
    status: "Status",
    amount: "Amount",
    paid: "Paid",
    unpaid: "Unpaid",
    viewInvoice: "View invoice",
    empty: "You don't have any invoices yet.",
  },

  updateModal: {
    header: "Add {unitLabel}s",
    body: "Add the number of {unitLabelPlural} to your subscription.",
    pricing: {
      discountApplied: "Discount applied to the subscription:",
      unitPrice: "Unit price:",
      quantity: "Quantity:",
      totalNewUnits: "Total for new units:",
      newSubscriptionTotal: "New subscription total value:",
    },
    prorationNote:
      "Subscription changes are prorated based on the remaining days in the current period. The full charge will apply next month.",
  },

  page: {
    findRightPlan: "Find the right plan for you",
    enterAmount: "Enter the amount",
    numberOf: "Number of {unit}"
  },
  billing: {
    title: "Select billing period",
    subtitle: "Choose how you want to pay",
    monthly: "Monthly",
    annual: "Annual",
    discountShort: "−{percent}%",
  },
};
